import { useState } from 'react'
import HeaderCard from './Cards/HeaderCard/HeaderCard'
import location from '../assets/location.svg'
import blessIdIcon from '../assets/blessIdIcon.svg'
import installIDIcon from '../assets/deviceMacIdIcon.svg'
import deviceMacIdIcon from '../assets/deviceMacIdIcon.svg'
import { useContext, useEffect } from 'react'
import DebugInfoContext from '../context/DebugContext';
import deviceIcon from '/device.svg';

const Insights = () => {
    const { isDataReady } = useContext(DebugInfoContext)
    const { headerData } = useContext(DebugInfoContext)
    const { formatMacAddress } = useContext(DebugInfoContext)

    const [headerCardInfo, setHeaderCardInfo] = useState({
        productInfo: {
            primaryText: '--',
            secondaryText: '--',
            icon: deviceIcon,
            status: null
        },
        account: {
            primaryText: '--',
            secondaryText: 'A/C Id : ',
            icon: '--',
            status: null
        },
        floorInfo: {
            primaryText: '--',
            secondaryText: 'Floor Id',
            icon: location,
            status: null
        },
        blessId: {
            primaryText: '--',
            secondaryText: 'Bless Id',
            icon: blessIdIcon,
            status: null
        },
        installId: {
            primaryText: '--',
            secondaryText: 'Install Id',
            icon: installIDIcon,
            status: null
        },
        // macId removed from initial state - will be added conditionally based on device type
    })

    function formatBlessId(blessId) {
        if (blessId) {
            const blessIdString = blessId.toString();
            const groups = blessIdString.match(/^(\d{4})(\d{3})(\d{3})$/);
            const formattedBlessId = `${groups[1]}-${groups[2]}-${groups[3]}`;
            return formattedBlessId;
        }
    }

    useEffect(() => {
        const getHedaerData = async () => {
            if (headerData != null) {
                const ProductName = `${headerData?.productTypeInfo?.name}`
                // For Z4 devices, use GEN4MacId for generation detection, otherwise use regular macId
                const macForGenDetection = headerData?.GEN4MacId || headerData?.macId;
                const startsWith600 = macForGenDetection?.startsWith('600');
                const startsWith300 = macForGenDetection?.startsWith('300');
                const startsWith500 = macForGenDetection?.startsWith('500');
                const productGen = startsWith600 ? 'GEN3' : startsWith300 ? 'GEN2' : startsWith500 ? 'PoE' : headerData?.isGen4Device ? 'GEN4' : 'Unknown';
                
                // Build new state object, excluding macId for Z4 devices
                const newState = {
                    productInfo: {
                        ...headerCardInfo.productInfo,
                        primaryText: ProductName,
                        secondaryText: productGen,
                        // icon: headerData?.accountInfo?.logoUrl
                    },
                    account: {
                        ...headerCardInfo.account,
                        primaryText: headerData?.accountInfo?.name,
                        secondaryText: 'A/C ID : ' + (headerData?.accountInfo?.id ? headerData?.accountInfo?.id : "-- "),
                        icon: headerData?.accountInfo?.logoUrl
                    },
                    floorInfo: {
                        ...headerCardInfo.floorInfo,
                        primaryText: headerData?.floorId,
                        status: headerData?.floorLiveStatus
                    },
                    blessId: {
                        ...headerCardInfo.blessId,
                        primaryText: formatBlessId(headerData?.blessId)
                    },
                    installId: {
                        ...headerCardInfo.installId,
                        primaryText: headerData?.installId
                    }
                };

                // Add macId only for non-Z4 devices
                if (!headerData?.GEN4MacId) {
                    newState.macId = {
                        primaryText: formatMacAddress(headerData?.macId),
                        secondaryText: 'Mac Id',
                        icon: deviceMacIdIcon,
                        status: null
                    };
                }

                // Add PoE Mac ID for PoE devices
                if (headerData?.poeMacId) {
                    newState.poeMacId = {
                        primaryText: formatMacAddress(headerData?.poeMacId),
                        secondaryText: 'PoE Mac Id',
                        icon: deviceMacIdIcon,
                        status: null
                    };
                }

                // Add Gen4 Mac ID for Z4 devices
                if (headerData?.GEN4MacId) {
                    newState.GEN4MacId = {
                        primaryText: formatMacAddress(headerData?.GEN4MacId),
                        secondaryText: 'Gen4 Mac Id',
                        icon: deviceMacIdIcon,
                        status: null
                    };
                }

                setHeaderCardInfo(newState);
            }
        }
        getHedaerData();
    }, [headerData, isDataReady]);
    

    const headerCards = Object.keys(headerCardInfo).map((key) => (
        <HeaderCard
            key={key}
            primaryText={headerCardInfo[key].primaryText}
            secondaryText={headerCardInfo[key].secondaryText}
            icon={headerCardInfo[key].icon}
            statusText={headerCardInfo[key].status}
        />
    ))

    return (
        <>
            {isDataReady ?
                <div className='shadow-md h-14 md:h-16 2xl:h-18 bg-rollover flex flex-col justify-center sticky top-10  2xl:top-12' >
                    <div className='overflow-x-scroll [&::-webkit-scrollbar]:hidden [-ms-overflow-style]:none [scrollbar-width]:none'>
                        <div className='flex flex-nowrap justify-evenly ml-4 md:ml-2 2xl:ml-4'>
                            {headerCards}
                        </div>
                    </div>
                </div>
                :
                <></>
            }
        </>
    )
}

export default Insights